// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const Bounce = registerClientReference(
    function() { throw new Error("Attempted to call Bounce() from the server but Bounce is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "Bounce",
);
export const Flip = registerClientReference(
    function() { throw new Error("Attempted to call Flip() from the server but Flip is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "Flip",
);
export const Icons = registerClientReference(
    function() { throw new Error("Attempted to call Icons() from the server but Icons is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "Icons",
);
export const Slide = registerClientReference(
    function() { throw new Error("Attempted to call Slide() from the server but Slide is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "Slide",
);
export const ToastContainer = registerClientReference(
    function() { throw new Error("Attempted to call ToastContainer() from the server but ToastContainer is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "ToastContainer",
);
export const Zoom = registerClientReference(
    function() { throw new Error("Attempted to call Zoom() from the server but Zoom is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "Zoom",
);
export const collapseToast = registerClientReference(
    function() { throw new Error("Attempted to call collapseToast() from the server but collapseToast is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "collapseToast",
);
export const cssTransition = registerClientReference(
    function() { throw new Error("Attempted to call cssTransition() from the server but cssTransition is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "cssTransition",
);
export const toast = registerClientReference(
    function() { throw new Error("Attempted to call toast() from the server but toast is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "toast",
);
export const useToast = registerClientReference(
    function() { throw new Error("Attempted to call useToast() from the server but useToast is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "useToast",
);
export const useToastContainer = registerClientReference(
    function() { throw new Error("Attempted to call useToastContainer() from the server but useToastContainer is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/react-toastify/dist/react-toastify.esm.mjs",
    "useToastContainer",
);
